import { CharacterCard } from './CharacterCard'
import { withCharacterCard } from './withCharacterCard'

const ConnectedCharacterCard = withCharacterCard(CharacterCard)

export { ConnectedCharacterCard as CharacterCard }
